import { QuestionnaireType } from '@enums/QuestionnaireTypes';
import { ApiResponse } from '@interfaces/index';
import { useQuery } from '@tanstack/react-query';
import { apiUrlConfig } from './configs/apiUrlConfig';
import createApiClient from './configs/httpHandler';

// Boosters and Drainers API Handler
export const boostersAndDrainersApiHandler = {
  getBoostersAndDrainersByQuestionnaireType: async (
    questionnaireType: QuestionnaireType,
  ): Promise<ApiResponse<BoostersAndDrainers>> =>
    createApiClient(apiUrlConfig.EXPRESS_BACKEND_V2).get(
      `/get-boosters-and-drainers-by-questionnaire-type/${questionnaireType}`,
    ),

  getBoostersAndDrainersByAssessmentId: async (
    assessmentId: number,
  ): Promise<ApiResponse<BoostersAndDrainers>> =>
    createApiClient(apiUrlConfig.EXPRESS_BACKEND_V2).get(
      `/get-boosters-and-drainers/${assessmentId}`,
    ),
};

// Boosters and Drainers Hooks
export const useBoostersAndDrainersHooks = {
  // GET /get-boosters-and-drainers-by-questionnaire-type/{questionnaireType}
  useBoostersAndDrainersByQuestionnaireType: (questionnaireType: QuestionnaireType) =>
    useQuery({
      queryKey: ['boosters-and-drainers-by-questionnaire-type', questionnaireType],
      queryFn: () =>
        boostersAndDrainersApiHandler.getBoostersAndDrainersByQuestionnaireType(questionnaireType),
      enabled: !!questionnaireType,
      // staleTime: 5 * 60 * 1000, // 5 minutes
    }),

  // GET /get-boosters-and-drainers/{assessmentId}
  useBoostersAndDrainersByAssessmentId: (assessmentId: number) =>
    useQuery({
      queryKey: ['boosters-and-drainers-by-assessment-id', assessmentId],
      queryFn: () =>
        boostersAndDrainersApiHandler.getBoostersAndDrainersByAssessmentId(assessmentId),
      enabled: !!assessmentId || assessmentId !== 0,
      // staleTime: 5 * 60 * 1000, // 5 minutes
    }),
};

export interface BoosterDrainerQuestion {
  id: number;
  questionnaireId: number;
  responseScaleId: number;
  questionText: string;
  orderId: number;
  required: boolean;
  icon: string | null;
  buttonText: string | null;
  description: string | null;
  isBrakeOff: boolean;
  createdAt: string;
  updatedAt: string;
  label: string;
  focusAreaWeight: number;
}

export interface BoosterDrainerItem {
  question: BoosterDrainerQuestion;
  assessmentId: number;
  priorityScore: number;
}

export interface BoostersAndDrainers {
  topBoosters: BoosterDrainerItem[];
  topDrainers: BoosterDrainerItem[];
}
